import { render, staticRenderFns } from "./PromotionPocApprovalForm.vue?vue&type=template&id=7a6c885f&"
import script from "./PromotionPocApprovalForm.vue?vue&type=script&lang=js&"
export * from "./PromotionPocApprovalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports